/*
 * Copyright © 2021-present Tacnode Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Tacnode Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Tacnode Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import { ExportOutlined } from '@ant-design/icons'
import { Space } from 'antd'
import { useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"

export function RedirectToBillingCenter() {
  const { t } = useTranslation()
  const { contractId } = useParams()

  return (
    <a href={`/billing-center/${contractId}`} target='_blank'>
      <Space>
        {t('Billing Center')}
        <ExportOutlined />
      </Space>
    </a>
  )
}